import { useTranslation } from "react-i18next";
import { HOME_VIEW_TEST_IDS } from "./home-view.utils";

interface HomeViewProps {
  testId?: string;
}

export function HomeView({ testId }: HomeViewProps = {}) {
  const { t } = useTranslation();

  return (
    <div
      data-testid={testId ?? HOME_VIEW_TEST_IDS.container}
      className="relative flex min-h-[calc(100vh-200px)] flex-col items-center justify-center overflow-hidden px-4 py-16"
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: "radial-gradient(ellipse 65% 55% at 50% 38%, oklch(0.93 0.06 72 / 0.22) 0%, transparent 68%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 w-full max-w-3xl space-y-8">
        <div className="animate-fade-up flex flex-col items-center gap-3 text-center">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-amber-600/75 dark:text-amber-500/75">
              {t("views.home.welcome")}
            </p>
            <h1
              data-testid={HOME_VIEW_TEST_IDS.welcomeMessage}
              className="mt-0.5 text-[2rem] font-bold leading-tight tracking-tight text-foreground"
            >
              {t("views.home.bcc")}
            </h1>
          </div>

          <div className="h-0.5 w-14 rounded-full bg-amber-400/55" />
        </div>

        <div className="animate-fade-up space-y-5 rounded-2xl border border-border/50 bg-card px-8 py-7 shadow-sm [animation-delay:0.14s]">
          <p data-testid={HOME_VIEW_TEST_IDS.heroTitle} className="text-[0.95rem] font-semibold leading-7 text-foreground">
            {t("views.home.heroTitle")}
          </p>

          <p data-testid={HOME_VIEW_TEST_IDS.partnershipText} className="text-sm leading-7 text-muted-foreground">
            {t("views.home.partnershipText")}
          </p>
          <p data-testid={HOME_VIEW_TEST_IDS.portalDescription} className="text-sm leading-7 text-muted-foreground">
            {t("views.home.portalDescription")}
          </p>
          <p data-testid={HOME_VIEW_TEST_IDS.valueProp} className="text-sm leading-7 text-muted-foreground">
            {t("views.home.valueProp")}
          </p>
        </div>

        <div className="animate-fade-up rounded-xl border border-amber-200 bg-amber-50 p-4 [animation-delay:0.28s] dark:border-amber-800 dark:bg-amber-950/30">
          <p
            data-testid={HOME_VIEW_TEST_IDS.tagline}
            className="text-center text-[0.9rem] font-medium italic text-amber-900 dark:text-amber-400"
          >
            ☕ {t("views.home.tagline")}
          </p>
        </div>
      </div>
    </div>
  );
}
